import axiosIns from '@/libs/axios'
import {getUserData} from '@/auth/utils'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchServices(ctx, datas){
        return new Promise((resolve, reject) => {
            axiosIns.get('/service/list/',{params:{...datas, store_id:getUserData().store_id}})
            .then(response=>resolve(response))
            .catch(error=>reject(error))
        })
    },
    fetchService(ctx, id){
        return new Promise((resolve,reject) => {
            axiosIns.get('/service/'+id)
            .then(response=>resolve(response))
            .catch(error=>reject(error))
        })
    },
    addService(ctx,data){
        return new Promise((resolve, reject) => {
            axiosIns.post('/service', data,
            {
              headers: {
                  'Content-Type': 'multipart/form-data'
              }
            }
            )
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
    },
    deleteService(ctx,id){
        return new Promise((resolve, reject) => {
            axiosIns.delete('/service/'+id).then(response => resolve(response)).catch(error=>reject(error))
        })
    },
    updateServiceTitle(ctx,data){
        return new Promise((resolve, reject) => {
            axiosIns.patch('/service/title',data).then(response => resolve(response)).catch(error=>reject(error))
        })
    },
    uploadServiceImage(ctx, { service_id, formData }) {
        return new Promise((resolve, reject) => {
          axiosIns.post(`/service/${service_id}/images`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
        })
      },
      fetchServiceImages(ctx, service_id) {
        return new Promise((resolve, reject) => {
          axiosIns.get(`/service/${service_id}/images`)
          .then(response => resolve(response))
          .catch(error => reject(error))
        })
      },
      deleteServiceImage(ctx, { service_id, image_id }) {
        return new Promise((resolve, reject) => {
          axiosIns.delete(`/service/${service_id}/images/${image_id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
        })
      },
  },
}
